var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Div from '@hellodarwin/core/lib/components/common/div';
import IntroDescription from '../components/IntroDescription';
import IntroTitle from '../components/IntroTitle';
const PlainIntro = (_a) => {
    var { direction, textAlign } = _a, props = __rest(_a, ["direction", "textAlign"]);
    return (_jsxs(Div, { flex: direction, gap: direction === 'row' ? 52 : 24, tablet: { gap: 16, flex: 'column' }, align: 'flex-start', style: { zIndex: 1, textAlign }, children: [_jsx(IntroTitle, Object.assign({}, props)), _jsx(IntroDescription, Object.assign({}, props))] }));
};
export default PlainIntro;
